import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { PartnerPlayerSummaryModel } from '@/modules/manage-player/type'
import { columns } from './constants'

interface PartnerPlayersTableProps {
	data: PartnerPlayerSummaryModel[]
	total: number
	isLoading: boolean
}

export default function PartnerPlayersTable({
	data,
	total,
	isLoading,
}: PartnerPlayersTableProps) {
	return (
		<DataTablePaginate
			columns={columns}
			data={data}
			totalItems={total}
			isLoading={isLoading}
		/>
	)
}
